export default __webpack_public_path__ + "static/media/1d0c7f4e4ccbf68786d5eb8599daeb42.svg";